(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc service
     * @name ihh-common-web.formUpdateUtilities
     * @require {formConstants} formConstants
     *
     * @description
     *  This service provides utilities useful for the formUpdate Controller.
     *  Primary use is to generate the string used by the alert banner
     */
    angular
        .module('ihh-common-web')
        .factory('formUpdateUtilities', formUpdateUtilities);

    formUpdateUtilities.$inject = ['formConstants', 'Utilities', '_'];

    /**
     * Controller definition
     *
     * @param {type} formConstants
     * @returns {string}
     */
    function formUpdateUtilities(formConstants, Utilities, _) {
        var parentIndexStringConstant = 'parentIndex';
        var indexStringConstant = 'index';

        /**
         * @ngdoc method
         * @name formatFieldName
         * @memberOf ihh-common-web.formUpdateUtilities
         * @private
         * @description
         *  This function will format a field name
         *  Removes ':'; Capitalizes first letter; Removes index data
         *
         * @param {string} fieldStr the unique string for the field
         * @param {string} label the user friendly label
         * @param {string} tplStr the prefix (exTpl, rxTpl, rxExTpl, ...)
         * @param {string} section a top level prefix
         * @returns {formattedString}
         */
        function formatFieldName(fieldStr, label, tplStr, section) {
            var tplStrLen;
            var formattedString;
            var dashIndex;
            var firstLetter;

            if (!angular.isDefined(label)) {
                formattedString = fieldStr;

                if (angular.isDefined(tplStr)) {
                    tplStrLen = tplStr.length;
                    formattedString = fieldStr.substring(tplStrLen, formattedString.length);
                    dashIndex = formattedString.indexOf('-');

                    if (dashIndex >= 0) {
                        formattedString = formattedString.substring(0, dashIndex);
                    }
                }

                firstLetter = formattedString.charAt(0);
                formattedString = firstLetter.toUpperCase() + formattedString.substring(1, formattedString.length);
            }
            else {
                formattedString = label;
                formattedString = formattedString.replace(':', '');
            }

            if (angular.isDefined(section)) {
                formattedString = section + ' ' + formattedString;
            }

            return formattedString;
        }

        /**
         * @ngdoc method
         * @name extractNumber
         * @memberOf ihh-common-web.formUpdateUtilities
         * @private
         * @description
         *  Extracts a number from a string (the last series of Number)
         *
         * @param {string} str the string to extract from
         * @param {string} indexStr the type of index requested
         * @returns {string}
         */
        function extractNumber(str, indexStr) {
            var regex;
            var match;

            if (parentIndexStringConstant === indexStr) {
                regex = /.*parentindex(\d+)/;
            }
            else if (indexStringConstant === indexStr) {
                regex = /.*index(\d+)/;
            }
            else {
                return undefined;
            }
            match = regex.exec(str);

            if (match !== null) {
                if (match.index === regex.lastIndex) {
                    regex.lastIndex++;
                }

                return parseInt(match[1], 10);
            }

            return undefined;
        }

        /**
         * @ngdoc method
         * @name getLegend
         * @memberOf ihh-common-web.formUpdateUtilities
         * @description
         *  Looks through the parent nodes for a fieldset element, and iff
         *  it finds one it looks through its immediate children for a
         *  legend element, and returns its text
         *
         * @param {object} node the input element node
         * @returns {string} the text in the legend
         */
        function getLegend(node) {
            while (node.parentNode) {
                node = node.parentNode;
                if (node.nodeName === 'FIELDSET') {
                    for (var i = 0; node.childNodes.length; i ++) {
                        if (node.childNodes[i].nodeName === 'LEGEND') {
                            return node.childNodes[i].textContent;
                        }
                    }
                }
            }
        }

        /**
         * @ngdoc method
         * @name generateInvalidFieldsArray
         * @memberOf ihh-common-web.formUpdateUtilities
         * @description
         *  Generates the invalid fields message for use in the alert banner
         *
         * @param {string} formId the name of the form
         * @returns {string}
         */
        function generateInvalidFieldsArray(formId, ihhFormIgnores) {
            var exTpl = formConstants.exerciseTemplates.exercise.prefix;
            var rxTplStr = formConstants.protocols.template.prefix;
            var rxExTplStr = formConstants.protocols.exercise.prefix;
            var myNodeList = document.getElementById(formId).querySelectorAll('.ng-invalid');
            var invalidFields = [];
            var invalidFieldIds = [];
            var missingItemString;
            var templateIndex;
            var invalidFieldDisplay;
            var exerciseIndex;

            //angular despises nodeLists
            for (var nodeListIndex = 0; nodeListIndex < myNodeList.length; nodeListIndex++) {
                var node = myNodeList[nodeListIndex];
                var ihhFormIgnoresIndex = _.findIndex(ihhFormIgnores, function (id) {
                    return id === node.id;
                });

                if (ihhFormIgnoresIndex === -1) {
                    node.data = {};
                    node.data.legend = getLegend(node);
                    invalidFields.push(node);
                }
            }

            if (invalidFields.length > 0) {
                angular.forEach(invalidFields, function (invalidField) {
                    var invalidFieldId = invalidField.id.toLowerCase();
                    var invalidFieldLabel;

                    if (Utilities.isDefinedAndNotNull(invalidField.labels) &&
                            invalidField.labels.length > 0) {
                        invalidFieldLabel = invalidField.labels[0].textContent;
                    }
                    else if (Utilities.isDefinedAndNotNull(invalidField.previousElementSibling) &&
                            angular.isDefined(invalidField.previousElementSibling.childNodes) &&
                            invalidField.previousElementSibling.childNodes.length > 0) {
                        invalidFieldLabel = invalidField.previousElementSibling.childNodes[0].textContent;
                    }
                    else if (Utilities.isDefinedAndNotNull(invalidField.parentElement.previousElementSibling)) {
                        invalidFieldLabel = invalidField.parentElement.previousElementSibling.innerText;
                    }

                    if (invalidFieldId.substring(0, rxTplStr.length) === rxTplStr) {
                        templateIndex = extractNumber(invalidFieldId, indexStringConstant);

                        invalidFieldDisplay = formatFieldName(invalidFieldId, invalidFieldLabel, rxTplStr);

                        templateIndex += 1;
                        missingItemString = Utilities.interpolateStrings(formConstants.protocols.template.text, [templateIndex, invalidFieldDisplay]);
                    }
                    else if (invalidFieldId.substring(0, rxExTplStr.length) === rxExTplStr) {
                        templateIndex = extractNumber(invalidFieldId, parentIndexStringConstant);
                        exerciseIndex = extractNumber(invalidFieldId, indexStringConstant);

                        invalidFieldDisplay = formatFieldName(invalidFieldId, invalidFieldLabel, rxExTplStr);

                        templateIndex += 1;
                        exerciseIndex += 1;
                        missingItemString = Utilities.interpolateStrings(formConstants.protocols.exercise.text, [templateIndex, exerciseIndex, invalidFieldDisplay]);
                    }
                    else if (invalidFieldId.substring(0, exTpl.length) === exTpl) {
                        templateIndex = extractNumber(invalidFieldId, indexStringConstant);

                        invalidFieldDisplay = formatFieldName(invalidFieldId, invalidFieldLabel, exTpl);

                        templateIndex += 1;
                        missingItemString = Utilities.interpolateStrings(formConstants.exerciseTemplates.exercise.text, [templateIndex, invalidFieldDisplay]);
                    }
                    else {
                        missingItemString = formatFieldName(invalidFieldId, invalidFieldLabel, undefined);
                    }

                    if (invalidField.data.legend) {
                        missingItemString = invalidField.data.legend + missingItemString;
                    }

                    invalidFieldIds.push(missingItemString);
                });
            }

            return invalidFieldIds;
        }

        // return public methods
        return {
            generateInvalidFieldsArray: generateInvalidFieldsArray
        };
    }

})();